<script setup>
import IconUser from '~icons/mdi/account'
import IconLogout from '~icons/mdi/sign-out'
import IconProfile from '~icons/mdi/account-circle'
import IconSettings from '~icons/mdi/settings'
import IconChevronDown from '~icons/mdi/chevron-down'

const userStore = useUserStore()
const localePath = useLocalePath()
</script>

<template>
  <v-menu>
    <template #activator="{ props }">
      <v-btn
        v-bind="props"
        data-test-id="menu-button"
        size="small"
        color="white"
        class="px-2"
      >
        <!--    <span class="text-white mr-1">{{ $t('layout.accountMenu.profile') }}</span> -->
        <v-icon size="24" :icon="IconUser" class="text-white" />
        <v-icon size="16" :icon="IconChevronDown" class="text-white ml-1" />
      </v-btn>
    </template>

    <v-list>
      <v-list-item
        :disabled="userStore.isUserDataPending"
        :prepend-icon="IconProfile"
        :title="$t('layout.accountMenu.profile')"
        :subtitle="userStore.data?.email"
        :to="localePath('/account/profile')"
      />
      <v-list-item
        :prepend-icon="IconSettings"
        :title="$t('customerReference.plural')"
        :to="localePath('/account/references')"
      />

      <v-divider />
      <v-list-item
        class="text-red"
        :title="$t('logout')"
        :prepend-icon="IconLogout"
        @click="userStore.logout()"
      />
    </v-list>
  </v-menu>
</template>
